/**
 * 締め処理
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/sales/requests/closing_processes`

 const sales_closing_process = {
   namespaced: true,
   actions: {
     create ({ commit }, { params }) {
       return new Promise( ( resolve ) => {
         Vue.$http.post(API_PATH, params).then( data => {
           let content = data.content
           commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
           resolve(content)
         } )
       })
     },
   },
 }

 export default sales_closing_process
